import { isLastItem, tokens } from '@airtel/air-design-system';
export var determineCtaType = bottomCta => {
  if ((bottomCta === null || bottomCta === void 0 ? void 0 : bottomCta.leftCta) && (bottomCta === null || bottomCta === void 0 ? void 0 : bottomCta.rightCta)) {
    return 'double';
  } else if ((bottomCta === null || bottomCta === void 0 ? void 0 : bottomCta.leftCta) || (bottomCta === null || bottomCta === void 0 ? void 0 : bottomCta.rightCta)) {
    return 'single';
  } else {
    return 'noCta';
  }
};
export var isSingleBtn = bottomCta => determineCtaType(bottomCta) === 'single';
export var trackOrderGridLayoutProps = () => {
  return {
    showGridLayout: true,
    gridLayoutProps: {
      hasColumn: true,
      colProps: {
        breakpoints: {
          lg: 4
        },
        noGutter: true
      },
      rowProps: {
        noMargin: true
      }
    }
  };
};
export var addNoVerticalPadding = function addNoVerticalPadding(linkedListData) {
  if (linkedListData === void 0) {
    linkedListData = [];
  }
  var linkedList = [...linkedListData];
  return linkedList === null || linkedList === void 0 ? void 0 : linkedList.map((item, index) => {
    var newItem = Object.assign({}, item);
    newItem.noPadding = true;
    newItem.style = {
      marginBottom: isLastItem(linkedList, index) ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_16
    };
    return newItem;
  });
};